<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
  <mat-select [(value)]="value" [compareWith]="compareWith" [formControl]="ChildControl" [multiple]="multiple"
              [required]="required" name="Role">
    <mat-option *ngFor="let res of Results" [value]="getOnlyId ? res.Id : res">{{res.Id}}</mat-option>
  </mat-select>
</mat-form-field>
